"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

const NAMESPACE = "new-aluminum-extrusion";
const IMAGE_BASE = "/image/new-version/more/AluminumExtrusion";

export default function AluminumExtrusionProcess() {
	const t = useTranslations(NAMESPACE);

	return (
		<section className="bg-[#ffffff] py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<h2 className="mb-6 text-center text-2xl font-bold leading-tight text-black sm:mb-8 sm:text-[30px] md:mb-10 md:text-4xl lg:mb-12">
					{t("extrusionProcessTitle")}
				</h2>

				<div className="grid items-start gap-8 lg:grid-cols-2 lg:gap-12">
					<div className="space-y-5 text-sm leading-relaxed text-black md:text-base">
						<p>{t("extrusionProcessDesc1")}</p>
						<p>
							{t("extrusionProcessDesc2Before")}
							<strong className="font-bold">{t("extrusionProcessDesc2Bold1")}</strong>
							{t("extrusionProcessDesc2Middle1")}
							<strong className="font-bold">{t("extrusionProcessDesc2Bold2")}</strong>
							{t("extrusionProcessDesc2After")}
						</p>
						<p>
							{t("extrusionProcessDesc3Before")}
							<strong className="font-bold">{t("extrusionProcessDesc3Bold1")}</strong>
							{t("extrusionProcessDesc3Middle1")}
							<strong className="font-bold">{t("extrusionProcessDesc3Bold2")}</strong>
							{t("extrusionProcessDesc3After")}
						</p>
					</div>

					<div className="relative aspect-[4/3.7] w-full overflow-hidden bg-white">
						<Image
							src={`${IMAGE_BASE}/what-is-the-aluminum-extrusion-process.webp`}
							alt={t("extrusionProcessImageAlt")}
							fill
							className="object-cover"
							sizes="(max-width: 1024px) 100vw, 50vw"
						/>
					</div>
				</div>
			</div>
		</section>
	);
}
